import React, { useEffect } from 'react'
import Fav from '@/images/favicon.ico'
import { isBrowser } from '@/lib/utils'
// import ReactGA from 'react-ga';
import { Helmet } from 'react-helmet'

function SEO(props: any) {
  const { description, keywords, title, canonical, image, jsonLd } = props || {}
  useEffect(() => {
    if (!isBrowser) { return }
    // ReactGA.initialize('UA-143184118-1', { gaAddress: 'https://baleen-cdn-g.bieyangapp.com/by/external/ga/analytics.js' })
    // ReactGA.pageview(window.location.pathname + window.location.search)

    var _hmt: any = _hmt || []
    ;(function () {
      let scripts = document.querySelectorAll('script')
      let has = Array.from(scripts).find(item => {
        return item.id === 'hm_baidu'
      })
      if (!has) {
        const hm = document.createElement("script");
        hm.id = 'hm_baidu'
        hm.src = "https://hm.baidu.com/hm.js?c7487e7cb62a4c055e9fd54769a8f897";
        const s: any = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
      }
    })()

    ;(function(){
      let el = document.createElement("script");
      el.src = "https://lf1-cdn-tos.bytegoofy.com/goofy/ttzz/push.js?a674d2ba34b0c3aef7a848c6b3ec2a15ff388b1ccbab2972f9832b6baa743f5bfd9a9dcb5ced4d7780eb6f3bbd089073c2a6d54440560d63862bbf4ec01bba3a";
      el.id = "ttzz";
      let s: any = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(el, s);
    })()

    ;(function() {
      (window as any).dataLayer = (window as any).dataLayer || [];
      function gtag(a: any, b: any){(window as any).dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-49XYHXLSHY');
    })()
  }, [])
  return (
    <React.Fragment>
      <Helmet>
        <title>{title}</title>
        <meta name="applicable-device" content="pc,mobile" />
        <meta name="og:title" property="og:title" content={title} />
        <meta name="og:description" property="og:description" content={description} />
        <meta name="og:site_name" property="og:site_name" content={'别样海外购'} />
        <meta name="og:type" property="og:type" content='website' />
        <meta name="og:author" property="og:author" content='别样海外购' />
        <meta name="og:image" property="og:image" content={image || 'https://www.bieyangapp.com/static/images/new_logo.png'} />
        <meta name="description" content={description} />
        {/* <meta name="image" content={image} /> */}
        {canonical ? <link rel="canonical" href={canonical} /> : null}
        {canonical ? <meta name="og:url" property="og:url" content={canonical} /> : null}
        {
          jsonLd ? (
            <script type="application/ld+json">
              {jsonLd}
            </script>
          ) : null
        }
        <link rel="shortcut icon" type='image/x-icon' href={Fav} />
        <meta name='keywords' content={keywords}></meta>
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-49XYHXLSHY"></script>
        <meta name='google-site-verification' content={'_JB8ytuqVrvViJAczGvWLMwXTgrgx4O7i5cRSY8O9To'}></meta>
        <meta name='baidu-site-verification' content={'code-s7H5z2bDV5'}></meta>
      </Helmet>
    </React.Fragment>
  )
}

export default SEO
